import { ExpertiseType, AssessmentActivities, TeachingActivity } from "../domain/SubjectModel";

export const displayExpertiseTypes = (selectedExpertise: ExpertiseType) => {
  var expertiseTypesText = [];

  if(selectedExpertise & ExpertiseType.Assessment){ expertiseTypesText.push("Assessment") }
  if(selectedExpertise & ExpertiseType.Industry){ expertiseTypesText.push("Industry, occupational or professional") }
  if(selectedExpertise & ExpertiseType.Teaching){ expertiseTypesText.push("Teaching, lecturing or training") }

  return expertiseTypesText;
}

export const displayAssessmentActivities = (selectedAssessmentActivities: AssessmentActivities) => {
  var selectedAssessmentActivitiesText = [];

  if(selectedAssessmentActivities & AssessmentActivities.MarkingAssessments){ selectedAssessmentActivitiesText.push("Making assessment judgements") }
  if(selectedAssessmentActivities & AssessmentActivities.StandardSettingAndAwardingQualifications){ selectedAssessmentActivitiesText.push("Standard setting and awarding qualifications") }
  if(selectedAssessmentActivities & AssessmentActivities.DesigningAndDevelopingAssessments){ selectedAssessmentActivitiesText.push("Designing and developing assessments") }
  if(selectedAssessmentActivities & AssessmentActivities.EvaluatingAssessments){ selectedAssessmentActivitiesText.push("Evaluating assessments or assessment approaches") }

  return selectedAssessmentActivitiesText;
}

export const displayTeachingActivities = (selectedTeachingActivities: TeachingActivity) => {
  var selectedTeachingActivitiesText = [];

  if(selectedTeachingActivities & TeachingActivity.TeachingOrLecturing){ selectedTeachingActivitiesText.push("Teaching or lecturing") }
  if(selectedTeachingActivities & TeachingActivity.Training){ selectedTeachingActivitiesText.push("Training") }
  if(selectedTeachingActivities & TeachingActivity.EducationalManagement){ selectedTeachingActivitiesText.push("Educational management") }
  if(selectedTeachingActivities & TeachingActivity.TeacherTraining){ selectedTeachingActivitiesText.push("Teacher training") }

  return selectedTeachingActivitiesText;
}